import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

const initializeStore = () => {
    const createStoreWithMiddleware = applyMiddleware( thunk )(createStore);
    const store = createStoreWithMiddleware(
        rootReducer(),
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );
    store.asyncReducers = {};

    store.injectReducer = (key, reducer) => {
        store.asyncReducers[key] = reducer;
        store.replaceReducer(rootReducer(store.asyncReducers));
        // return store;
    }
    return store;
};

export default initializeStore;


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js